import { useCallback, useState } from 'react';

import { Step } from './types';

const headerTitleByStep: Record<Step, string> = {
  [Step.ADD_CARD_FORM]: 'Add Your Gift Card',
  [Step.CARD_SUMMARY]: 'Gift Card Summary',
  [Step.CHECK_BALANCE]: 'Gift Card Balance',
};

export function useGiftCardsActionSheet({
  isCheckBalanceFlow = false,
}: { isCheckBalanceFlow?: boolean } = {}) {
  const [actionSheetOpen, setActionSheetOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState<Step>(Step.ADD_CARD_FORM);
  const [closeConfirmationOpen, setCloseConfirmationOpen] = useState(false);

  const handleActionSheetOpen = useCallback(() => {
    setActionSheetOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setActionSheetOpen(false);
    setCurrentStep(Step.ADD_CARD_FORM);
  }, []);

  // Called when user tries to close from CARD_SUMMARY step
  const handleRequestClose = useCallback(() => {
    if (currentStep === Step.CARD_SUMMARY) {
      // Close the ActionSheet first, then show confirmation
      setActionSheetOpen(false);
      setCloseConfirmationOpen(true);
      return;
    }
    handleClose();
  }, [currentStep, handleClose]);

  // User chose to stay and add the gift card
  const handleConfirmStay = useCallback(() => {
    setCloseConfirmationOpen(false);
    setActionSheetOpen(true);
  }, []);

  // User chose to leave
  const handleConfirmLeave = useCallback(() => {
    setCloseConfirmationOpen(false);
    setCurrentStep(Step.ADD_CARD_FORM);
  }, []);

  const headerTitle =
    isCheckBalanceFlow && currentStep === Step.CHECK_BALANCE
      ? 'Gift Card Balance'
      : headerTitleByStep[currentStep];

  return {
    actionSheetOpen,
    handleActionSheetOpen,
    handleClose,
    handleRequestClose,
    currentStep,
    setCurrentStep,
    headerTitle,
    closeConfirmationOpen,
    handleConfirmStay,
    handleConfirmLeave,
  };
}
